var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("looker-dashboard-component", {
    key: _vm.keyTemplate,
    attrs: {
      maintenance: _vm.maintenance,
      title: _vm.$t("use_metrics.dashboard_government"),
      description: _vm.$t("use_metrics.des_dashboard_government"),
      url: _vm.dashboardUrl,
      breadcrumbs: [],
    },
    on: { updateDashboard: _vm.onReloadDashboard },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }